import { Observable } from '@reactivex/rxjs';
import { Timebar } from '../index';
import styles from './styles.less';
import { mapTimebarFragment } from '../with-timebar-data';
import mapPropsStream from 'react-recompose/mapPropsStream';
import createEventHandler from 'react-recompose/createEventHandler';
import { ExpressionTemplates } from '@graphistry/viz/src/components/expressions';

export function renderTimebarList({
    width,
    height,
    loading = false,
    onLoading,
    addTimebar,
    removeTimebar,
    templates = [],
    timebars = [],
    className = '',
    style = {},
    ...props
}) {
    let timebar = {};
    let timebarItems = [];
    if (timebars.length > 0) {
        timebar = timebars[timebars.length - 1];
        if (!timebar) {
            loading = true;
            timebar = { id: 'pending', componentType: '' };
        }
        const timebarWidth = Math.max(0, width);
        const timebarHeight = Math.max(0, height - 30);
        const { minTime, maxTime, details, summary } = mapTimebarFragment(timebar, { width: timebarWidth, height: timebarHeight });
        timebarItems.push(
            <Timebar
                data={timebar}
                yAxisWidth={50}
                xAxisHeight={25}
                minTime={minTime}
                maxTime={maxTime}
                details={details}
                summary={summary}
                width={timebarWidth}
                height={timebarHeight}
                onLoading={onLoading}
                key={`${timebars.length - 1}: ${timebar.id}`}
            />
        );
    }
    return (
        <div style={style} className={className + ' ' + styles['timebars-list']}>
            <ExpressionTemplates
                loading={loading}
                isClearable={false}
                showDataTypes={false}
                menuPlacement="top"
                templates={templates}
                addExpression={addTimebar}
                placeholder="Add timebar for..."
                className={styles['timebars-select-control']}
                value={getSelectedTemplate(templates, timebar)}
            />
            {timebarItems}
        </div>
    );
}

function getSelectedTemplate(templates, { name, dataType, identifier, componentType }) {
    let selectedTemplate = null;
    if (identifier && templates && templates.length) {
        for (let i = -1, n = templates.length; ++i < n; ) {
            const t = templates[i];
            if (t &&
                t.name === name &&
                t.dataType === dataType &&
                t.identifier === identifier &&
                t.componentType === componentType) {
                selectedTemplate = { ...t, value: i, label: `${identifier} (${dataType})` };
            }
        }
    }
    return selectedTemplate;
}

export const withTimebarListBehaviors = mapPropsStream(propsStream_ => {

    const propsStream = Observable.from(propsStream_);
    const { handler: onLoading, stream: loadingBins } = createEventHandler();
    const { handler: addTimebar, stream: addEvents } = createEventHandler();
    const { handler: removeTimebar, stream: removeEvents } = createEventHandler();

    const loadingBinsObs = loadingBins
        .distinctUntilChanged().auditTime(10)
        .withLatestFrom(propsStream, (loading, props) => ({ ...props, loading }));
    const addTimebarObs = addEvents
        .withLatestFrom(propsStream)
        .mergeMap(([{ name, dataType, componentType }, { timebars = [], $falcor }]) => {
            let obs = $falcor.call('add', [componentType, name, dataType]);
            if (timebars && timebars.length) {
                obs = obs.concat(
                    Observable.merge(...timebars.map(({ id }) => $falcor.call('remove', [id])))
                );
            }
            return obs;
        })
        .ignoreElements();

    const removeTimebarObs = removeEvents
        .withLatestFrom(propsStream)
        .mergeMap(([{ id }, { $falcor }]) => $falcor.call('remove', [id]))
        .ignoreElements();

    return propsStream
        .merge(loadingBinsObs, addTimebarObs, removeTimebarObs)
        .map((props) => ({ ...props, onLoading, addTimebar, removeTimebar }));
});

export const TimebarList = withTimebarListBehaviors(renderTimebarList);
